import { render, staticRenderFns } from "./ArchitectureComponents.vue?vue&type=template&id=177b5fe1&"
import script from "./ArchitectureComponents.vue?vue&type=script&lang=js&"
export * from "./ArchitectureComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports